/**
 * Ryan O'Dowd
 * 2022-03-21
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  return {
    dialogTitle: { // @TODO: combine with other dialogs
      color: isDarkMode ? colors.white : colors.black,
      fontSize: globalScale * 22,
      fontFamily: fonts.primaryBold,
      marginBottom: globalScale * 8,
    },
    dialogText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      marginTop: 4,
      marginBottom: 4,
      color: isDarkMode ? colors.white : colors.black,
    },
    outerContainer: {
      flexGrow: 1,
    },
    innerContainerWrapper: {
      flex: 1, // @TODO: not sure how to make this full height
      marginBottom: safeAreaInsets.bottom,
    },
    progressBarWrapper: {
      width: '100%',
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 16,
      paddingLeft: 0,
      height: 4,
    },
    progressBar: {
      backgroundColor: `${colors.white}44`,
    },
    gameView: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerOptionIcon: {
      fontSize: globalScale * 16,
      color: colors.white,
      marginHorizontal: globalScale * 4,
    },

    // @TODO: move some of these to commonStyles // @TODO: this is yeeted...move to shared component?
    headerOptionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: 8, // to make room for the game name/help
    },
    headerOption: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 4,
    },
    headerOptionText: {
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    innerContainer: {
      flex: 1,
    },
    dialogInnerScrollWrapper: {
      display: 'flex',
    },
    bold: {
      display: 'inline',
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
